import axios from "axios";
import { baseURL } from "@/general";
const adminApi = axios.create({
  baseURL: `${baseURL}`,
});
// User Login
export const userLogin = async (values) => {
  try {
    const response = await adminApi.post("general/login", values);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// Examen de titulación
export const registerExamen = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "registroExamenTitulacion/insertarRegistroExamenTitulacion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const validExamenActivo = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get(
      "RegistroExamenTitulacion/validaExamenActivo",
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const validGrupoActivo = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get(
      "inscripcion/validaInscripcionActiva",
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getExamenTitulacion = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get(
      "examenTitulacion/getExamenTitulacion",
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getInformacionExamenTitulacionAlumnos = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "examenTitulacion/getInformacionExamenTitulacionAlumnos",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

//verificación de acceso
export const verificaAcceso = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "general/verificaAcceso",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// verifica aviso de privacidad
export const validaAvisoPrivacidad = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get(
      "general/validaAvisoPrivacidad",
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const registraExamenTitulacionAlumno = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "registroExamenTitulacion/registroExamenTitulacionAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const obtainRecursosVisuales = async () => {
  try {
    const response = await adminApi.get(
      "recursosVisuales/getRecursosVisualesActivos"
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const resetPassword = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "general/resetPassword",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const incribirGrupoAlumno = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "inscripcion/inscribirGrupo",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getComprobanteInscripcion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "inscripcion/generarComprobante",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const verifyNivelInicial = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "nivelInicial/validaNivelInicial",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const verifyAsignaturasAlumno = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.get(
      "grupo/validaAsignaturasAlumno",
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getGruposByAsignatura = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "grupo/getGruposByAsignatura",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getInscripcionCursos = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.get("inscripcion/getInscripcion", config);
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getPeriodoInscripcion = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.get(
      "periodoInscripcion/getPeriodoInscripcion",
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getRegistrosExamenesTitulacionBySemestreAlumno = async (
  values
) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "registroExamenTitulacion/getRegistrosExamenesTitulacionBySemestreAlumno",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getEncuestaAlumno = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "semestreEncuesta/getEncuestaAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getGuiaAccesoExamenTitulacion = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.get(
      "recursosVisuales/getGuiaAccesoExamenTitulacion",
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const insertarRespuestaEncuesta = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "respuestaEncuesta/insertarRespuestaEncuesta",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getInfoAlumno = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { 'x-api-key': token } };
  try {
    const response = await adminApi.get('alumno/getInfoAlumno', config);
    return response.data;
  } catch (error) {
    const response = error.response;
    return response;
  }
}


export const validaDatosAlumno = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("alumno/validaCAE", config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const editarCorreoAlumno = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "alumno/editarCorreoAlumno",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};



export const getInformacionExamenPosgradoAlumnos = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "examenPosgrado/getInformacionExamenPosgradoAlumnos",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


export const getRegistrosExamenesPosgradoBySemestreAlumno = async (
  values
) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "registroExamenPosgrado/getRegistrosExamenesPosgradoBySemestreAlumno",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


export const registraExamenPosgradoAlumno = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "registroExamenPosgrado/registroExamenPosgradoAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

